var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.activeFeeTypes,"track-by":"uuid","label":"name","multiple":true,"allowEmpty":!!_vm.allowEmpty,"placeholder":"Tipo de Cuota","selectedLabel":"","selectLabel":"","deselectLabel":""},on:{"input":_vm.notifyChange},model:{value:(_vm.feeTypes),callback:function ($$v) {_vm.feeTypes=$$v},expression:"feeTypes"}})
}
var staticRenderFns = []

export { render, staticRenderFns }